import { BigNumber, ethers } from 'ethers';
import { generateContractIdOfCoinHtlc } from '../utils/htlc';
import { HtlcServiceInterface, NewContractType, TxReturnType } from './type';

export default class CoinHtlcService implements HtlcServiceInterface {
  private htlc: ethers.Contract;

  private signer: ethers.Signer;

  private signerAddress: string;

  constructor(
    htlcAddress: string,
    htlcAbi: any,
    signer: ethers.Signer,
    signerAddress: string,
  ) {
    this.signer = signer;
    this.htlc = new ethers.Contract(htlcAddress, htlcAbi, signer);
    this.signerAddress = signerAddress;
  }

  static async build(
    htlcAddress: string,
    htlcAbi: any,
    signer: ethers.Signer,
  ): Promise<CoinHtlcService> {
    const signerAddress = await signer.getAddress();
    return new CoinHtlcService(htlcAddress, htlcAbi, signer, signerAddress);
  }

  async newContract(
    chainId: string,
    hashlock: string,
    timelock: number,
    receiver: string,
    amount: BigNumber,
  ): Promise<NewContractType> {
    let tx: ethers.ContractTransaction;
    let receipt: ethers.ContractReceipt;
    const contractId = generateContractIdOfCoinHtlc(
      this.signerAddress,
      receiver,
      amount,
      hashlock,
      timelock,
    );

    try {
      tx = await this.htlc.newContract(
        chainId,
        timelock,
        amount,
        hashlock,
        receiver,
        {
          value: amount,
        },
      );
      receipt = await tx.wait();
      console.log(
        `TX | signer: ${tx.from}, nonce: ${tx.nonce}, htlc.newContract()`,
      );
    } catch (error) {
      console.error(`Error htlc.newContract()`);
      throw error;
    }
    return { contractId, tx, receipt };
  }

  async withdraw(hashlock: string, preimage: string): Promise<TxReturnType> {
    let tx;
    let receipt;
    try {
      tx = await this.htlc.withdraw(hashlock, preimage);
      receipt = await tx.wait();
      console.log(
        `TX | signer: ${tx.from}, nonce: ${tx.nonce}, htlc.withdraw()`,
      );
    } catch (error) {
      console.error(`Error htlc.withdraw()`);
      throw error;
    }
    return { tx, receipt };
  }

  async refund(hashlock: string): Promise<TxReturnType> {
    let tx;
    let receipt;
    try {
      const gasLimit = await this.htlc.estimateGas.refund(hashlock);
      tx = await this.htlc.refund(hashlock, {
        gasLimit,
      });
      receipt = await tx.wait();
      console.log(`TX | signer: ${tx.from}, nonce: ${tx.nonce}, htlc.refund()`);
    } catch (error) {
      console.error(`Error htlc.refund()`);
      throw error;
    }
    return { tx, receipt };
  }
}
